import { View } from 'react-native'
import { LanguageCode } from '@ca/common'
import Flag from '@ui/elements/Flags/Flag'

interface Props {
  language: LanguageCode
}

export default function LanguageAction({ language }: Props) {
  return (
    <View className="rounded-xs overflow-hidden">
      <Flag width={24} height={16} code={language} />
    </View>
  )
}
